import { Injectable } from "@angular/core";
import { Adapter } from "src/app/adapter";
import * as moment from "moment";

export class MenuUsers {
  constructor(
    public id: number,
    public menuName: string,
    public user: string,
    public changeID: string,
    public lastUpdated: moment.Moment
  ) {}
}

@Injectable({
  providedIn: "root",
})
export class MenuUsersAdapter implements Adapter<MenuUsers> {
  adapt(item: any): MenuUsers {
    return new MenuUsers(
      item.UUROWID,
      item.UUAUAUTHNAME,
      item.UUUSER,
      item.URCHANGEID,
      item.URLASTUPDATED
    );
  }
}
